<app-header></app-header>

<!-- Container -->
<section class="fullscreen contact-block">

  <!-- Form -->
  <div class="content">
    <div class="column-12">
      <h1 class="text-h1">Colaboremos juntos</h1>
    </div>
    <app-form class="form-style"></app-form>
  </div>

  <!-- Givens -->
  <div class="section-givens">
    <div class="section-givens__block">
      <h4>Háblanos</h4>
      <p><a class="link" href="mailto:hola@digboost.com">hola@digboost.com</a></p>
    </div>
    <div class="section-givens__block">
      <h4>Visítanos</h4>
      <p>Calle de Torrelaguna, 77, 28043 Madrid</p>
    </div>
    <div class="section-givens__block section-givens__block--number">
      <h4>Llámanos</h4>
      <p><a class="link" href="tel:+34 91 360 49 60">+34 91 360 49 60 </a></p>
      <p>/ <a class="link" href="tel:+34 608 040 985">+34 608 040 985</a></p>
    </div>
  </div>

</section>

<app-footer></app-footer>
